import {POSTERMYWALL_DESCRIPTION_TEXT_TYPE} from '@FormMakerReact/components/postermywall-description-text/postermywall-description-text';
import {registerRightPanelSector} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';
import {DescriptionFontControl} from './components/description-font-control/description-font-control';
import {DescriptionSizeControl} from './components/description-size-control/description-size-control';
import {DescriptionTextColorControl} from './components/description-text-color-control/description-text-color-control';
import {DescriptionAlignmentControl} from './components/description-alignment-control/description-alignment-control';

registerRightPanelSector(POSTERMYWALL_DESCRIPTION_TEXT_TYPE, {
  title: window.i18next.t('pmwjs_form_maker_description'),
  controls: [DescriptionFontControl, DescriptionSizeControl, DescriptionTextColorControl, DescriptionAlignmentControl],
});